import { useEffect, useRef } from "react";
import { getId, Icon, Modal } from "@fluentui/react";
import { StyleUtils } from "../../../common/views/StyleUtils";
import { Utils } from "../../../common/views/Utils";
import { useInvoicePrintVM } from "../../viewmodels/InvoicePrintVM";
import InvoicePrintView from "./InvoicePrintView";
import { OrderModel } from "../../../orders/models/OrderModel";

type InvoiceDetailProps = {
    id: string;
    onClose: () => void;
    onOrderDetail?: (order: OrderModel) => void;
}

export default function InvoiceDetailView({ id, onClose, onOrderDetail }: InvoiceDetailProps) {
    const hasLoaded = useRef(false);
    const vm = useInvoicePrintVM();

    useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        vm.get(id);
    }, [vm, id]);

    const isMobile = window.innerWidth <= 500;
    const titleId: string = getId('title');
    const subtitleId: string = getId('subText');
    const width6 = Utils.getColumnWidth(6);

    const modalHeader = () => {
        return <div className="popup-header">
            <div className="ms-Grid ml--10 mr--10">
                <div className="ms-Grid-row bold">
                    <div className={width6}>
                        Invoice Details
                    </div>
                    <div className={width6 + " right"}>
                        <Icon iconName="ChromeClose" className="pointer" onClick={onClose} />
                    </div>
                </div>
            </div>
        </div>;
    }

    return <>
        <Modal
            titleAriaId={titleId}
            subtitleAriaId={subtitleId}
            isOpen={true}
            onDismiss={onClose}
            isBlocking={false}
            isModeless={false}
            styles={StyleUtils.getModalWidthStyles(450)}
        >
            {modalHeader()}

            <div
                id={subtitleId}
                className={(isMobile ? "mobile-" : "") + "popup-body"}
                style={{ maxHeight: isMobile ? "100vh" : "80vh", overflowY: "auto" }}
            >
                {!Utils.isArrayNullOrEmpty(vm.invoices) &&
                    vm.invoices.length > 0 &&
                    <InvoicePrintView
                        key={vm.listHash}
                        invoice={vm.invoices[0]}
                        bankAccounts={vm.bankAccounts}
                        contacts={vm.contacts}
                        onOrderDetail={onOrderDetail}
                    />}
            </div>
        </Modal>
    </>;
}